// extracted by mini-css-extract-plugin
export default {"taskModalHeader":"styles_taskModalHeader__GQYsm","heading":"styles_heading__y+Qx2","headingTemplate":"styles_headingTemplate__JdaDc","subHeading":"styles_subHeading__wmMsP"};